module.exports = __webpack_public_path__ + "partylineManage/img/volume.c4174e36.svg";